import { Container, ListGroup } from 'react-bootstrap';

import { Link } from 'react-router-dom';
import { LocalizationKeys } from '../../constants/localizationKeys';
import React from 'react';
import routes from '../../routes/routes';
import { useTranslation } from 'react-i18next';

interface AdministratorScreenProps {}

export const AdministratorScreen: React.FC<AdministratorScreenProps> = () => {
    const [t] = useTranslation();

    return (
        <Container>
            <h2>{t(LocalizationKeys.ADMIN_TITLE)}</h2>
            <ListGroup>
                <ListGroup.Item>
                    <Link to={`${routes.documentType}/0`}>{t(LocalizationKeys.ADMIN_PAGES_DOCUMENT_TYPE)}</Link>
                </ListGroup.Item>
                <ListGroup.Item>
                    <Link to={`${routes.group}/0`}>{t(LocalizationKeys.ADMIN_PAGES_GROUP)}</Link>
                </ListGroup.Item>
                <ListGroup.Item>
                    <Link to={routes.moderationUser}>{t(LocalizationKeys.ADMIN_PAGES_USERS)}</Link>
                </ListGroup.Item>
            </ListGroup>
        </Container>
    );
};
